import { useAppSelector } from '@/hooks/storeHooks';
import { IUserInfo } from '@/pages/Dashboard/types';

const useUserInfo = (): IUserInfo => {
  const userInfo = useAppSelector(({ app }) => app.userInfo);
  return { ...userInfo };
};

export default useUserInfo;
